// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1199px) and (min-width: 1024px) {
  .AdminDashboard-widthInner-UwAeO {
    width: 100%;
    border-radius: 0;
    margin: 0 auto;
  }

  .AdminDashboard-aboutGrid-DMLRc img {
    position: relative;
    top: -25px !important;
  }

  .AdminDashboard-responsiveView-oJIKI {
    width: 100% !important;
    max-width: 175px !important;
  }

  .AdminDashboard-positionFive-g9r2f {
    top: 28% !important;
  }

  .AdminDashboard-positionTwo-WZbO9 {
    top: 28% !important;
  }

  .AdminDashboard-responsiveContentOne-rSiK5 {
    top: -50px !important;
  }

  .AdminDashboard-positionFour-RaSHW {
    top: -50px !important;
  }

  .AdminDashboard-totalCss-GT0Be {
    width: 100% !important;
  }


}

@media (max-width: 1024px) {
  .AdminDashboard-navbar-expand-lg-_QF2_ .AdminDashboard-navbar-toggler-_g958 {
    display: block !important;
    position: absolute;
    top: 23px;
    right: 20px;
  }

  .AdminDashboard-profileImgSection-Tg_s5 {
    padding: 18px;
  }
}

@media (max-width: 1023px) and (min-width: 768px) {

  .AdminDashboard-navigationLink-nKF7Q a {
    color: var(--primary-foreground) !important;
  }

  .AdminDashboard-widthInner-UwAeO {
    width: 100%;
    border-radius: 0;
    margin: 0 auto;
  }

  .AdminDashboard-responsiveContentOne-rSiK5 {
    width: 300px !important;
    position: absolute !important;
    top: -42px !important;
    left: -5% !important;
  }

  .AdminDashboard-positionTwo-WZbO9 {
    top: 24% !important;
    left: -5% !important;
  }

  .AdminDashboard-positionThree-RKEKb {
    top: 70% !important;
    left: -5% !important;
  }

  .AdminDashboard-positionFour-RaSHW {
    top: -42px !important;
    right: -5% !important;
  }

  .AdminDashboard-positionFive-g9r2f {
    top: 20% !important;
    right: -5% !important;
  }

  .AdminDashboard-positionSix-F3YPO {
    top: 70% !important;
    right: -5% !important;
  }

  .AdminDashboard-responsiveView-oJIKI {
    width: 100% !important;
    max-width: 115px !important;
  }

  .AdminDashboard-aboutGrid-DMLRc img {
    top: -1px !important;
  }

  .AdminDashboard-contentOne-ULlqD h1 {
    font-size: 16px !important;
  }

  .AdminDashboard-contentOne-ULlqD p {
    font-size: 12px !important;
  }


  .AdminDashboard-totalCss-GT0Be {
    width: 100% !important;
  }

  .AdminDashboard-padding-VAaXs {
    padding: 0px 0 0 60px !important;
  }

  .AdminDashboard-singleCard-TFRcY {
    width: 100% !important;
  }

  .AdminDashboard-navigationLink-nKF7Q a:hover,
  .AdminDashboard-navigationLink-nKF7Q a:focus,
  .AdminDashboard-navigationLink-nKF7Q a:active {
    border-bottom: 2px solid transparent;
  }
}

@media screen and (max-width: 823px) {
  .AdminDashboard-navbar-collapse-K7ZAN.AdminDashboard-show-OahiG {
    right: 0% !important;
    top: 0 !important;
  }

  .AdminDashboard-navbar-collapse-K7ZAN {
    position: fixed !important;
    height: 100vh !important;
    width: 100% !important;
    background: #fff !important;
    right: -100% !important;
    -webkit-transition: 0.5s !important;
    transition: 0.5s !important;
  }
}

@media (max-width: 767px) {
  .AdminDashboard-content-Q41fP {
    float: none;
  }

  .AdminDashboard-mr-auto-pK7cD.AdminDashboard-navbar-nav-gg9IG {
    padding-bottom: 80px !important;
  }

  .AdminDashboard-navigationLink-nKF7Q a {
    color: var(--primary-foreground) !important;
  }

  .AdminDashboard-footer-U3u4h {
    padding: 35px 0 0 15px;
  }

  .AdminDashboard-widthInner-UwAeO {
    width: 100%;
    margin: 0px auto 0 auto;
    border-radius: 0;
  }

  .AdminDashboard-responsiveNoPadding-V2pOv {
    padding: 0px !important;
  }

  .AdminDashboard-contentOne-ULlqD {
    position: relative !important;
    text-align: left !important;
    width: auto !important;
    padding: 0px 15px !important;
  }

  .AdminDashboard-aboutContainer-naeD5 {
    padding: 30px 0 30px !important;
  }

  .AdminDashboard-noPosition-y9Uob {
    left: 0 !important;
    right: 0 !important;
    top: 0 !important;
  }

  .AdminDashboard-mobimleImg-Ca0GB {
    display: none !important;
  }

  .AdminDashboard-totalCss-GT0Be {
    width: 100% !important;
  }

  .AdminDashboard-imgWidth-lahS5 {
    padding: 18px !important;
  }

  .AdminDashboard-searchInput-hLjm4,
  .AdminDashboard-assignProviderSearchInput-jTFZp {
    max-width: 100% !important;
  }

  .AdminDashboard-exportText-xAELR {
    display: inline-block;
  }

  .AdminDashboard-gridSystem-GX5lq {
    grid-template-columns: auto !important;
  }

  .AdminDashboard-padding-VAaXs {
    padding: 52px 0 0 0 !important;
  }

  .AdminDashboard-heading-TKuqT {
    padding: 30px 0 24px !important;
  }

  .AdminDashboard-singleCard-TFRcY {
    width: 100% !important;
  }

  .AdminDashboard-displayGrid-M1Sgd {
    grid-template-columns: 100% !important;
    grid-gap: 12px;
  }

  .AdminDashboard-boxInner-nCP9r {
    padding: 35px 0 !important;
  }

  .AdminDashboard-navigationLink-nKF7Q a:hover,
  .AdminDashboard-navigationLink-nKF7Q a:focus,
  .AdminDashboard-navigationLink-nKF7Q a:active {
    border-bottom: 2px solid transparent;
  }
}

@media (max-width: 480px) and (min-width: 320px) {
  .AdminDashboard-whiteDropdown-Yg7Rw select {
    width: 120px !important;
  }
}

.AdminDashboard-totalCss-GT0Be {
	font-size: 20px;
	font-weight: 400;
	color: var(--primary-foreground);
	padding: 20px;
	font-weight: 600;
	border-top: 1px solid var(--primary-border);
}

.AdminDashboard-box-NNBYB {
	color: var(--primary-foreground);
	margin-bottom: 30px;
	border: 1px solid var(--primary-border);
	border-radius: 12px;
	word-break: break-word;
}

.AdminDashboard-box-NNBYB h2 {
	text-align: center;
}

.AdminDashboard-boxInner-nCP9r {
	font-size: 17px;
	text-align: center;
	padding: 50px 10px
}

.AdminDashboard-textCenterDashboard-V4qnh {
	text-align: center;
}

.AdminDashboard-boxBg-p_bb1 {
	background: var(--background-secondary);
	padding: 20px 0 0;
	border-top-left-radius: 12px;
	border-top-right-radius: 12px;
}

.AdminDashboard-overviewIcon-MkaNN {
	width: 20px;
	height: 25px;
	margin-right: 6px;
}

.AdminDashboard-sectionOne-RMRcf {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.AdminDashboard-fontCss-DRuLu {
	font-size: 22px;
	margin: 0;
	font-weight: 600;
}

.AdminDashboard-displayGrid-M1Sgd {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-gap: 7px;
	padding: 0 7px;
}

@media (max-width:1400px) and (min-width:1200px) {
	.AdminDashboard-displayGrid-M1Sgd {
		grid-template-columns: 100%;
	}

	.AdminDashboard-boxInner-nCP9r {
		padding: 30px 10px
	}
}`, "",{"version":3,"sources":["webpack://./src/components/responsive-common.css","webpack://./src/components/SiteAdmin/AdminDashboard/AdminDashboard.css"],"names":[],"mappings":"AAAA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;;AAGF;;AAEA;EACE;IACE,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE;IACE,2CAA2C;EAC7C;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;IAC7B,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;;EAGA;IACE,sBAAsB;EACxB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;IACxB,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,mCAA2B;IAA3B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sCAAsC;IACtC,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,oCAAoC;EACtC;AACF;;AAGA;EACE;IACE,uBAAuB;EACzB;AACF;;AC1PA;CACC,eAAe;CACf,gBAAgB;CAChB,gCAAgC;CAChC,aAAa;CACb,gBAAgB;CAChB,2CAA2C;AAC5C;;AAEA;CACC,gCAAgC;CAChC,mBAAmB;CACnB,uCAAuC;CACvC,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB;AACD;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,uCAAuC;CACvC,iBAAiB;CACjB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,SAAS;CACT,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,qCAAqC;CACrC,aAAa;CACb,cAAc;AACf;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC;CACD;AACD","sourcesContent":["@media (max-width: 1199px) and (min-width: 1024px) {\n  .widthInner {\n    width: 100%;\n    border-radius: 0;\n    margin: 0 auto;\n  }\n\n  .aboutGrid img {\n    position: relative;\n    top: -25px !important;\n  }\n\n  .responsiveView {\n    width: 100% !important;\n    max-width: 175px !important;\n  }\n\n  .positionFive {\n    top: 28% !important;\n  }\n\n  .positionTwo {\n    top: 28% !important;\n  }\n\n  .responsiveContentOne {\n    top: -50px !important;\n  }\n\n  .positionFour {\n    top: -50px !important;\n  }\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n\n}\n\n@media (max-width: 1024px) {\n  .navbar-expand-lg .navbar-toggler {\n    display: block !important;\n    position: absolute;\n    top: 23px;\n    right: 20px;\n  }\n\n  .profileImgSection {\n    padding: 18px;\n  }\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n\n  .navigationLink a {\n    color: var(--primary-foreground) !important;\n  }\n\n  .widthInner {\n    width: 100%;\n    border-radius: 0;\n    margin: 0 auto;\n  }\n\n  .responsiveContentOne {\n    width: 300px !important;\n    position: absolute !important;\n    top: -42px !important;\n    left: -5% !important;\n  }\n\n  .positionTwo {\n    top: 24% !important;\n    left: -5% !important;\n  }\n\n  .positionThree {\n    top: 70% !important;\n    left: -5% !important;\n  }\n\n  .positionFour {\n    top: -42px !important;\n    right: -5% !important;\n  }\n\n  .positionFive {\n    top: 20% !important;\n    right: -5% !important;\n  }\n\n  .positionSix {\n    top: 70% !important;\n    right: -5% !important;\n  }\n\n  .responsiveView {\n    width: 100% !important;\n    max-width: 115px !important;\n  }\n\n  .aboutGrid img {\n    top: -1px !important;\n  }\n\n  .contentOne h1 {\n    font-size: 16px !important;\n  }\n\n  .contentOne p {\n    font-size: 12px !important;\n  }\n\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n  .padding {\n    padding: 0px 0 0 60px !important;\n  }\n\n  .singleCard {\n    width: 100% !important;\n  }\n\n  .navigationLink a:hover,\n  .navigationLink a:focus,\n  .navigationLink a:active {\n    border-bottom: 2px solid transparent;\n  }\n}\n\n@media screen and (max-width: 823px) {\n  .navbar-collapse.show {\n    right: 0% !important;\n    top: 0 !important;\n  }\n\n  .navbar-collapse {\n    position: fixed !important;\n    height: 100vh !important;\n    width: 100% !important;\n    background: #fff !important;\n    right: -100% !important;\n    transition: 0.5s !important;\n  }\n}\n\n@media (max-width: 767px) {\n  .content {\n    float: none;\n  }\n\n  .mr-auto.navbar-nav {\n    padding-bottom: 80px !important;\n  }\n\n  .navigationLink a {\n    color: var(--primary-foreground) !important;\n  }\n\n  .footer {\n    padding: 35px 0 0 15px;\n  }\n\n  .widthInner {\n    width: 100%;\n    margin: 0px auto 0 auto;\n    border-radius: 0;\n  }\n\n  .responsiveNoPadding {\n    padding: 0px !important;\n  }\n\n  .contentOne {\n    position: relative !important;\n    text-align: left !important;\n    width: auto !important;\n    padding: 0px 15px !important;\n  }\n\n  .aboutContainer {\n    padding: 30px 0 30px !important;\n  }\n\n  .noPosition {\n    left: 0 !important;\n    right: 0 !important;\n    top: 0 !important;\n  }\n\n  .mobimleImg {\n    display: none !important;\n  }\n\n  .totalCss {\n    width: 100% !important;\n  }\n\n  .imgWidth {\n    padding: 18px !important;\n  }\n\n  .searchInput,\n  .assignProviderSearchInput {\n    max-width: 100% !important;\n  }\n\n  .exportText {\n    display: inline-block;\n  }\n\n  .gridSystem {\n    grid-template-columns: auto !important;\n  }\n\n  .padding {\n    padding: 52px 0 0 0 !important;\n  }\n\n  .heading {\n    padding: 30px 0 24px !important;\n  }\n\n  .singleCard {\n    width: 100% !important;\n  }\n\n  .displayGrid {\n    grid-template-columns: 100% !important;\n    grid-gap: 12px;\n  }\n\n  .boxInner {\n    padding: 35px 0 !important;\n  }\n\n  .navigationLink a:hover,\n  .navigationLink a:focus,\n  .navigationLink a:active {\n    border-bottom: 2px solid transparent;\n  }\n}\n\n\n@media (max-width: 480px) and (min-width: 320px) {\n  .whiteDropdown select {\n    width: 120px !important;\n  }\n}","@import '../../../components/responsive-common.css';\n\n.totalCss {\n\tfont-size: 20px;\n\tfont-weight: 400;\n\tcolor: var(--primary-foreground);\n\tpadding: 20px;\n\tfont-weight: 600;\n\tborder-top: 1px solid var(--primary-border);\n}\n\n.box {\n\tcolor: var(--primary-foreground);\n\tmargin-bottom: 30px;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 12px;\n\tword-break: break-word;\n}\n\n.box h2 {\n\ttext-align: center;\n}\n\n.boxInner {\n\tfont-size: 17px;\n\ttext-align: center;\n\tpadding: 50px 10px\n}\n\n.textCenterDashboard {\n\ttext-align: center;\n}\n\n.boxBg {\n\tbackground: var(--background-secondary);\n\tpadding: 20px 0 0;\n\tborder-top-left-radius: 12px;\n\tborder-top-right-radius: 12px;\n}\n\n.overviewIcon {\n\twidth: 20px;\n\theight: 25px;\n\tmargin-right: 6px;\n}\n\n.sectionOne {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.fontCss {\n\tfont-size: 22px;\n\tmargin: 0;\n\tfont-weight: 600;\n}\n\n.displayGrid {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(3, 1fr);\n\tgrid-gap: 7px;\n\tpadding: 0 7px;\n}\n\n@media (max-width:1400px) and (min-width:1200px) {\n\t.displayGrid {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.boxInner {\n\t\tpadding: 30px 10px\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"widthInner": `AdminDashboard-widthInner-UwAeO`,
	"aboutGrid": `AdminDashboard-aboutGrid-DMLRc`,
	"responsiveView": `AdminDashboard-responsiveView-oJIKI`,
	"positionFive": `AdminDashboard-positionFive-g9r2f`,
	"positionTwo": `AdminDashboard-positionTwo-WZbO9`,
	"responsiveContentOne": `AdminDashboard-responsiveContentOne-rSiK5`,
	"positionFour": `AdminDashboard-positionFour-RaSHW`,
	"totalCss": `AdminDashboard-totalCss-GT0Be`,
	"navbar-expand-lg": `AdminDashboard-navbar-expand-lg-_QF2_`,
	"navbar-toggler": `AdminDashboard-navbar-toggler-_g958`,
	"profileImgSection": `AdminDashboard-profileImgSection-Tg_s5`,
	"navigationLink": `AdminDashboard-navigationLink-nKF7Q`,
	"positionThree": `AdminDashboard-positionThree-RKEKb`,
	"positionSix": `AdminDashboard-positionSix-F3YPO`,
	"contentOne": `AdminDashboard-contentOne-ULlqD`,
	"padding": `AdminDashboard-padding-VAaXs`,
	"singleCard": `AdminDashboard-singleCard-TFRcY`,
	"navbar-collapse": `AdminDashboard-navbar-collapse-K7ZAN`,
	"show": `AdminDashboard-show-OahiG`,
	"content": `AdminDashboard-content-Q41fP`,
	"mr-auto": `AdminDashboard-mr-auto-pK7cD`,
	"navbar-nav": `AdminDashboard-navbar-nav-gg9IG`,
	"footer": `AdminDashboard-footer-U3u4h`,
	"responsiveNoPadding": `AdminDashboard-responsiveNoPadding-V2pOv`,
	"aboutContainer": `AdminDashboard-aboutContainer-naeD5`,
	"noPosition": `AdminDashboard-noPosition-y9Uob`,
	"mobimleImg": `AdminDashboard-mobimleImg-Ca0GB`,
	"imgWidth": `AdminDashboard-imgWidth-lahS5`,
	"searchInput": `AdminDashboard-searchInput-hLjm4`,
	"assignProviderSearchInput": `AdminDashboard-assignProviderSearchInput-jTFZp`,
	"exportText": `AdminDashboard-exportText-xAELR`,
	"gridSystem": `AdminDashboard-gridSystem-GX5lq`,
	"heading": `AdminDashboard-heading-TKuqT`,
	"displayGrid": `AdminDashboard-displayGrid-M1Sgd`,
	"boxInner": `AdminDashboard-boxInner-nCP9r`,
	"whiteDropdown": `AdminDashboard-whiteDropdown-Yg7Rw`,
	"box": `AdminDashboard-box-NNBYB`,
	"textCenterDashboard": `AdminDashboard-textCenterDashboard-V4qnh`,
	"boxBg": `AdminDashboard-boxBg-p_bb1`,
	"overviewIcon": `AdminDashboard-overviewIcon-MkaNN`,
	"sectionOne": `AdminDashboard-sectionOne-RMRcf`,
	"fontCss": `AdminDashboard-fontCss-DRuLu`
};
module.exports = ___CSS_LOADER_EXPORT___;
